import { defaultNumberOfRewardDays } from './reward-periods';
import { ESubIds, subIds } from '~/types/GioNode';

export enum ESplitDate {
  SWITCH1 = '2024-03-01',
  SWITCH2 = '2024-07-01',
  SWITCH3 = '2024-12-15',
  SWITCH4 = '2025-01-02',
}

export type SubDirectAmountType = {
  [key in (typeof subIds)[number]]: number;
};

export const originalSubDirectAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 3100,
  [ESubIds.BASICP]: 12400,
  [ESubIds.PREMIUM]: 31000,
  [ESubIds.PREMIUMP]: 124000,
  [ESubIds.MASTER]: 310000,
  [ESubIds.MASTERP]: 1240000,
  [ESubIds.COLLECTOR]: 0,
  [ESubIds.VIP]: 0,
};

export const switch1SubDirectAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 1550,
  [ESubIds.BASICP]: 6200,
  [ESubIds.PREMIUM]: 15500,
  [ESubIds.PREMIUMP]: 62400,
  [ESubIds.MASTER]: 150500,
  [ESubIds.MASTERP]: 620000,
  [ESubIds.COLLECTOR]: 0,
  [ESubIds.VIP]: 0,
};

export const switch2SubDirectAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 1000,
  [ESubIds.BASICP]: 4000,
  [ESubIds.PREMIUM]: 10000,
  [ESubIds.PREMIUMP]: 40000,
  [ESubIds.MASTER]: 100000,
  [ESubIds.MASTERP]: 400000,
  [ESubIds.COLLECTOR]: 200,
  [ESubIds.VIP]: 30000,
};

export const switch3SubDirectAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 900,
  [ESubIds.BASICP]: 3_600,
  [ESubIds.PREMIUM]: 9_000,
  [ESubIds.PREMIUMP]: 36_000,
  [ESubIds.MASTER]: 90_000,
  [ESubIds.MASTERP]: 360_000,
  [ESubIds.COLLECTOR]: 200,
  [ESubIds.VIP]: 30000,
};

export const switch4SubDirectAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 900,
  [ESubIds.BASICP]: 3_600,
  [ESubIds.PREMIUM]: 9_000,
  [ESubIds.PREMIUMP]: 36_000,
  [ESubIds.MASTER]: 90_000,
  [ESubIds.MASTERP]: 360_000,
  [ESubIds.COLLECTOR]: 180,
  [ESubIds.VIP]: 30000,
};

export const originalSubTotalRewardAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 27_900,
  [ESubIds.BASICP]: 49_600,
  [ESubIds.PREMIUM]: 278_000,
  [ESubIds.PREMIUMP]: 496_000,
  [ESubIds.MASTER]: 2_780_000,
  [ESubIds.MASTERP]: 4_960_000,
  [ESubIds.COLLECTOR]: 0,
  [ESubIds.VIP]: 0,
};

export const originalSubDailyRewardAmount: SubDirectAmountType = Object.entries(
  originalSubTotalRewardAmount,
).reduce((prev, cur) => {
  prev[Number(cur[0]) as ESubIds] = cur[1] / defaultNumberOfRewardDays;
  return prev;
}, {} as SubDirectAmountType);

export const switch1SubTotalRewardAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 13_950,
  [ESubIds.BASICP]: 24_800,
  [ESubIds.PREMIUM]: 139_000,
  [ESubIds.PREMIUMP]: 248_000,
  [ESubIds.MASTER]: 1_390_000,
  [ESubIds.MASTERP]: 2_480_000,
  [ESubIds.COLLECTOR]: 0,
  [ESubIds.VIP]: 0,
};

export const switch1SubDailyRewardAmount: SubDirectAmountType = Object.entries(
  switch1SubTotalRewardAmount,
).reduce((prev, cur) => {
  prev[Number(cur[0]) as ESubIds] = cur[1] / defaultNumberOfRewardDays;
  return prev;
}, {} as SubDirectAmountType);

export const switch2SubTotalRewardAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 7000,
  [ESubIds.BASICP]: 14_000,
  [ESubIds.PREMIUM]: 70_000,
  [ESubIds.PREMIUMP]: 140_000,
  [ESubIds.MASTER]: 700_000,
  [ESubIds.MASTERP]: 1_400_000,
  [ESubIds.COLLECTOR]: 800,
  [ESubIds.VIP]: 120_000,
};

export const switch2SubDailyRewardAmount: SubDirectAmountType = Object.entries(
  switch2SubTotalRewardAmount,
).reduce((prev, cur) => {
  prev[Number(cur[0]) as ESubIds] = cur[1] / defaultNumberOfRewardDays;
  return prev;
}, {} as SubDirectAmountType);

export const switch3SubTotalRewardAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 6_300,
  [ESubIds.BASICP]: 12_600,
  [ESubIds.PREMIUM]: 63_000,
  [ESubIds.PREMIUMP]: 126_000,
  [ESubIds.MASTER]: 630_000,
  [ESubIds.MASTERP]: 1_260_000,
  [ESubIds.COLLECTOR]: 800,
  [ESubIds.VIP]: 120_000,
};

export const switch3SubDailyRewardAmount: SubDirectAmountType = Object.entries(
  switch3SubTotalRewardAmount,
).reduce((prev, cur) => {
  prev[Number(cur[0]) as ESubIds] = cur[1] / defaultNumberOfRewardDays;
  return prev;
}, {} as SubDirectAmountType);

export const switch4SubTotalRewardAmount: SubDirectAmountType = {
  [ESubIds.BASIC]: 6_300,
  [ESubIds.BASICP]: 12_600,
  [ESubIds.PREMIUM]: 63_000,
  [ESubIds.PREMIUMP]: 126_000,
  [ESubIds.MASTER]: 630_000,
  [ESubIds.MASTERP]: 1_260_000,
  [ESubIds.COLLECTOR]: 720,
  [ESubIds.VIP]: 120_000,
};

export const switch4SubDailyRewardAmount: SubDirectAmountType = Object.entries(
  switch4SubTotalRewardAmount,
).reduce((prev, cur) => {
  prev[Number(cur[0]) as ESubIds] = cur[1] / defaultNumberOfRewardDays;
  return prev;
}, {} as SubDirectAmountType);
